import React from 'react';
import { ConfirmModal, ConfirmModalProps } from '@ar/components/shared/ConfirmModal';
import { useSupplierStore } from '@ar/stores/SupplierStore';
import { useInvoiceStore } from '@ar/stores/InvoicesStore';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTransaction } from '@ar/network/AccountsReceivable.network';
import { toast } from '@notch-ordering/ui-components';
import CheckIcon from '@icons/check-icon.svg';
import { FETCH_TRANSACTION_ACTIVITY_QUERY_KEY, FETCH_TRANSACTION_QUERY_KEY,
    FETCH_TRANSACTIONS_QUERY_KEY } from '@ar/hooks/queries/InvoicesQueries.hook';
import { getGpoId } from '@v2/utils/GPOUtils';

export type DoNotChargeModalProps = Partial<ConfirmModalProps>;

export const DoNotChargeModal : React.FC<DoNotChargeModalProps> = (props) => {
    const { modals, setModal } = useInvoiceStore();
    const { supplierLoginData } = useSupplierStore();
    const gpoId = getGpoId(supplierLoginData);
    const queryClient = useQueryClient();
    const handleOnClose = ():void => {
        if (props?.onClose) props.onClose();
        setModal('doNotChargeInvoice', false);
    };
    const updateTransactionMutation = useMutation(updateTransaction, {
        onSuccess: () => {
            toast.show({
                message: 'Invoice status updated',
                icon: <CheckIcon/>,
            });
            queryClient.invalidateQueries([FETCH_TRANSACTIONS_QUERY_KEY]);
            queryClient.invalidateQueries([FETCH_TRANSACTION_ACTIVITY_QUERY_KEY]);
            queryClient.invalidateQueries([FETCH_TRANSACTION_QUERY_KEY]);
            handleOnClose();
        },
        onError: () => {
            toast.show({
                message: 'Failed to update invoice status',
            });
        },
    });

    const handleOnConfirm = ():void => {
        if (props?.onConfirm) props.onConfirm();
        updateTransactionMutation.mutate({
            supplierID: supplierLoginData?.supplier_id,
            gpoId,
            transactionID: modals?.transaction.id,
            body: {
                do_no_charge: true,
            },
        });
    };
    return <ConfirmModal
        onClose={handleOnClose}
        isLoading={updateTransactionMutation.isLoading}
        isOpen={modals.doNotChargeInvoice}
        title={'Confirm you want this invoice to be marked as do not charge.'}
        prompt={'No automatic payments will be tried for this invoice and you can only collect payment for this invoice manually. '}
        onConfirm={handleOnConfirm}
        {...props}/>;
};
